import CustomIcons from "../GlobalComponents/CustomIcons";
import React, { Component } from "react";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import { connect } from "react-redux";
import { setDataLandingTotal } from "./landing_Actions";
import Logger from "../../models/Logger";

class Footerv2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      landing: [],
      servicioOpen: !(window.innerWidth <= 1024),
      politicasOpen: !(window.innerWidth <= 1024),
      isMobile: window.innerWidth <= 1024,
      politicas: [
        {
          label: 'Código de ética',
          enlace: 'https://www.alkomprar.com/codigo-etica',
          icon: 'arrowFooter'
        },
        {
          label: 'Política de privacidad',
          enlace: 'https://www.alkomprar.com/politicas/privacidad',
          icon: 'arrowFooter'
        },
        {
          label: 'Términos y condiciones',
          enlace: 'https://www.alkomprar.com/politicas/terminos-condiciones',
          icon: 'arrowFooter'
        },
        {
          label: 'Línea ética',
          enlace: 'https://multicrm.colcomercio.com.co/linea_etica/',
          icon: 'phone'
        }
      ]
    };
    Logger.setLogger(this.constructor.name);
  }

  installPrompt = null;

  toggleOpen(section) {
    if (this.state.isMobile) {
      this.setState((prevState) => ({
        [section]: !prevState[section],
      }));
    }
  }
  
  getFooterData = () => {
    fetch(settings.backend.list_front_modules, {
      method: "GET",
      headers: settings.headers_super_auth,
    })
      .then(FetchResponses.processResponse)
      .then(this.successResponse)
      .catch((error) => {
        Logger.error(error);
      });
  }

  installAppAndroid = () => {
      window.dataLayer.push({event: 'ga_event',category: 'pwa',action: 'show',label: 'prompt'}); 
      this.installPrompt.prompt();
      this.installPrompt.userChoice.then((choice) => {
        if (choice.outcome !== 'accepted') {
          window.dataLayer.push({
            event: 'ga_event',
            category: 'pwa',
            action: 'close',
            label: 'prompt'
          });
        }
        this.installPrompt = null;
      })   
    
  }

  componentDidMount = () => {
    this.getFooterData()

    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);

    window.addEventListener('appinstalled', e => {
      window.dataLayer.push({
        event: 'ga_event',
        category: 'pwa',
        action: 'instalacion'
      });
    });  
  };

  componentWillUnmount() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
  }

  handleBeforeInstallPrompt = (e) => {
    e.preventDefault();
    this.installPrompt = e;
    if ((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true) {
      return;
    }
  }

  successResponse = (response) => {
    this.props.setDataLandingTotal(response);
    localStorage.setItem("footer", JSON.stringify(response.modules));
    this.setState({
      landing: response.modules,
    });
  };

  installAppAndroid = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  
    if (!isMobile || isStandalone || !this.installPrompt) {
      // Si está en PC, ya está instalada o no hay prompt disponible, no hace nada
      return;
    }
  
    // Si pasa las condiciones, dispara el prompt
    window.dataLayer.push({ event: 'ga_event', category: 'pwa', action: 'show', label: 'prompt' });
    this.installPrompt.prompt();
  
    this.installPrompt.userChoice.then((choice) => {
      if (choice.outcome !== 'accepted') {
        window.dataLayer.push({ event: 'ga_event', category: 'pwa', action: 'close', label: 'prompt' });
      } else {
        window.dataLayer.push({ event: 'ga_event', category: 'pwa', action: 'install', label: 'prompt' });
      }
      this.installPrompt = null; // Evita que vuelva a lanzarse
    });
  };
  

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 1000 });
  };

  render() {
    const { servicioOpen, politicasOpen } = this.state;
    return (
      <>
        <footer className="home-footer">
          <div className="socials-container">
            <div className="socials-header">
                <span className="title">Síguenos en</span>
            </div>
            <div className="socials-content">
              {this.state.landing.map(land => {
                  if (land.module_type === "Contacto" && land.redirect_link !== null) {
                    let social = land.title;
                    let icon = "";

                    if (social.indexOf("Twitter") >= 0) {
                      icon = "twitter";
                    }
                    if (social.indexOf("Facebook") >= 0) {
                      icon = "facebook";
                    }
                    if (social.indexOf("Instagram") >= 0) {
                      icon = "instagram";
                    }
                    if (social.indexOf("Youtube") >= 0) {
                      icon = "youtube";
                    }
                    return <span>
                      <a href={land.redirect_link} target="_blank" rel="noopener noreferrer">
                        <CustomIcons className="footer-icon-container" icon={icon} />
                      </a>
                    </span>
                  }
              })}
            </div>
          </div>
          <div className="footer-content">
            <div className="footer-section contact-container">
              <span
                className="footer-title"
                onClick={() => this.toggleOpen("servicioOpen")}
              >
                Servicio al cliente{" "}
                <CustomIcons
                  icon={servicioOpen ? "dropdownArrowBlack" : 'dropdownDownArrowBlack'}
                  className={"dropdown-icon"}
                />{" "}
              </span>
              <ul className={servicioOpen ? "" : "closed"}>
                <li>
                  Colombiana de Comercio S.A <span>NIT 890.900.943-1</span>
                </li>
                <li></li> {/* Para generar una separacion extra */}
                {this.state.landing.map((land) => {
                  if (
                    land.module_type === "Contacto" &&
                    land.content !== null &&
                    land.title.indexOf("Medellín") >= 0
                  ) {
                    return (
                     <div className="contact-item">
                       <li key={Math.random()}>
                       {land.title}{" "}
                        <a href={`tel:${land.content}`} target="_blank" className="normal_link">{land.content}</a>
                      </li>

                      <CustomIcons icon='phone' className={`icon-contact-footer tel:${land.content}`} onClick={() => window.open(`tel:${land.content}`, '_blank')}/>
                     </div>
                    );
                  }
                  if (
                    land.module_type === "Contacto" &&
                    land.content !== null &&
                    land.title.indexOf("Nacional") >= 0
                  ) {
                    return (
                      <div className="contact-item">
                        <li key={Math.random()}>
                          {land.title}{" "}
                          <a href={`tel:${land.content}`} target="_blank" className="normal_link">{land.content}</a>
                        </li>

                        <CustomIcons icon='phone' className={`icon-contact-footer tel:${land.content}`}  data-link={`tel:${land.content}`} onClick={() => window.open(`tel:${land.content}`, '_blank')}/>
                      </div>
                    );
                  }
                })}
                <div className="contact-item">
                  <li>
                    Línea <span>WhatsApp</span>{" "}
                    <a href="https://api.whatsapp.com/send?phone=573336495765" target="_blank" className="normal_link">
                      333 649 57 65
                    </a>
                  </li>

                  <CustomIcons icon='whatsappfooter' className='icon-contact-footer' onClick={() => window.open('https://api.whatsapp.com/send?phone=573336495765', '_blank')}/>
                </div>

                <li>
                  <span><a href="mailto:alkomprarcartera.requerimientos@corbeta.com.co"  className="normal_link">alkomprarcartera.requerimientos@corbeta.com.co</a></span>
                </li>
              </ul>
            </div>

            <div className="footer-section politicas-container">
              <span
                onClick={() => this.toggleOpen("politicasOpen")}
                className="footer-title"
              >
                Conoce nuestras políticas{" "}
                <CustomIcons
                  icon={politicasOpen ? "dropdownArrowBlack" : 'dropdownDownArrowBlack'}
                  className={"dropdown-icon"}
                />
              </span>
              <ul className={politicasOpen ? "" : "closed"}>
                {this.state.politicas.map((politica) => {
                  return (
                    <div className="contact-item">
                      <li>
                        <a href={politica.enlace} target="_blank" className="underline_link">{politica.label}</a>
                      </li>
                      <CustomIcons icon={politica.icon} className='icon-contact-footer' onClick={() => window.open(politica.enlace, '_blank')}/>
                    </div>
                  )
                })}
              </ul>
            </div>

            <div className="app-container">
              <h6 className="footer-title">Descarga tu app</h6>
              <div className="icon-container-footer">
                <CustomIcons className="footer-icon-container" icon="android" onClick={this.installAppAndroid} />
                <CustomIcons className="footer-icon-container" icon="apple" />
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

const mapStateToProps = state => ({
  landing: state
});
export default connect(mapStateToProps, { setDataLandingTotal })(Footerv2);